import { Action } from "redux";

export const OPEN_MOBILE_MENU = "OPEN_MOBILE_MENU";
export const OPEN_MEGA_DROPDOWN_MENU = "OPEN_MEGA_DROPDOWN_MENU";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_ALL_OVERLAYS = "CLOSE_ALL_OVERLAYS";

export interface CloseAllOverlaysAction extends Action {
    type: typeof CLOSE_ALL_OVERLAYS;
}

export interface OpenMobileMenuAction extends Action {
    type: typeof OPEN_MOBILE_MENU;
    menu?: any;
    subMenu?: any;
}

export interface OpenMegaDropdownMenuAction extends Action {
    type: typeof OPEN_MEGA_DROPDOWN_MENU;
    menu?: any;
    subMenu?: any;
}

export interface OpenModalAction extends Action {
    type: typeof OPEN_MODAL;
    stickyLink?: any;
    modal?: any;
}

export type OverlayAction = CloseAllOverlaysAction | OpenMobileMenuAction | OpenMegaDropdownMenuAction | OpenModalAction;
